export default __webpack_public_path__ + "images/V2.ab2f747.png";